import avPlayerStore from "@/store/avPlayer.store";
import summaryCommonStore from "@/store/summaryCommon.store";

class AVPlayerHelper {
  public static advOrBackAudio(time: number) {
    const { isAudioPlaying, playingTime, audioPlayerIns } =
      avPlayerStore.getState();
    if (!isAudioPlaying) return;
    const t = playingTime + time;
    audioPlayerIns?.setCurrentTime(t);
  }

  public static pauseAudio() {
    avPlayerStore.getState().audioPlayerIns?.pause();
  }

  // 通过前进/后退/拖拽进度条更改时间，都会恢复成默认跟随状态
  public static changeSliderValueCb() {
    summaryCommonStore.getState().setIsScrolled(false);
  }

  // video/audio点击段落，自动跟随
  public static textJumpCb() {
    summaryCommonStore.getState().setIsScrolled(false);
  }
}

export default AVPlayerHelper;
